
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Stock = () => {
    const [items, setItems] = useState([]);
    const [calculations, setCalculations] = useState({});

    const fetchProducts = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Unauthorized: Token not found');
            }

            const response = await fetch(`${process.env.REACT_APP_ADMIN_API_URL}/api/products`, {
                headers: { token },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();

            
            console.log("data",data)
            const allItems = data.map((item) => ({
                ItemName: item.itemname,
                Brand: item.brand,
                SellingUnit: item.sellingunit,
                MCSellingPrice: item.mcsellingprice,
                product_id: item.productid,
                sku:item.sku,
            }));

            setItems(allItems);
            console.log("items",items)
            
            // Initialize calculations object
            const initialCalculations = {};
            allItems.forEach(item => {
                initialCalculations[item.product_id] = {
                    quantity: '',
                    pricePerUnit: '',
                    totalPrice: 0
                };
            });
            setCalculations(initialCalculations);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleInputChange = (productId, field, value) => {
        setCalculations(prev => {
            const prevProduct = prev[productId] || { quantity: '', pricePerUnit: '', totalPrice: 0 };
            
            const updatedProduct = {
                ...prevProduct,
                [field]: value
            };
            
            const quantity = parseFloat(field === 'quantity' ? value : updatedProduct.quantity) || 0;
            const pricePerUnit = parseFloat(field === 'pricePerUnit' ? value : updatedProduct.pricePerUnit) || 0;
            updatedProduct.totalPrice = (quantity * pricePerUnit).toFixed(2);
            
            return {
                ...prev,
                [productId]: updatedProduct
            };
        });
    };
     const handleConfirmPurchase = async () => {
        try {
            const productsToPurchase = items.map((item) => {
                const productCalculation = calculations[item.product_id] || {};
                console.log("sku",item.sku,item.product_id)

                const { quantity, pricePerUnit, totalPrice } = productCalculation;
                if (quantity > 0) {
                    return {
                        ProductId: item.product_id,
                        SKU: item.sku,
                        ItemName: item.ItemName,
                        quantity,
                        priceperunit: pricePerUnit,
                        totalprice: totalPrice
                    };
                }
                return null;
            }).filter(product => product !== null); 

            const response = await axios.post(`${process.env.REACT_APP_ADMIN_API_URL}/api/purchasedstock`, { productsToPurchase }, {
                headers: {
                    token: localStorage.getItem('token'),
                    'Content-Type': 'application/json'
                }
            });
            

            console.log("response from cart", response);
            alert("Purchase Confirmed!");
        } catch (error) {
            console.error("Error confirming purchase", error);
            alert("There was an error confirming your purchase.");
        }
    };


    return (
        <div className="p-6 max-w-6xl mx-auto">
            <h1 className="text-3xl font-bold mb-6 text-gray-800">Stock Management</h1>
            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Item Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Quantity
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Price/Unit
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Total Price
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {items.map((item) => (
                            <tr key={item.product_id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {item.ItemName} 
                                    
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <input
                                        type="number"
                                        value={calculations[item.product_id]?.quantity || ''}
                                        onChange={(e) => handleInputChange(item.product_id, 'quantity', e.target.value)}
                                        className="w-24 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="Quantity"
                                        min="0"
                                    />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <input
                                        type="number"
                                        value={calculations[item.product_id]?.pricePerUnit || ''}
                                        onChange={(e) => handleInputChange(item.product_id, 'pricePerUnit', e.target.value)}
                                        className="w-24 px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        placeholder="Price"
                                        min="0"
                                        step="0.01"
                                    />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    ₹{calculations[item.product_id]?.totalPrice || '0.00'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="flex justify-end mt-6 gap-x-4"> {/* Add gap-x-4 for space between buttons */}
                    <button
                        className="px-6 py-2 bg-green-600 text-white font-medium rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        Add Via Google Sheets
                    </button>
                    <button
                        onClick={handleConfirmPurchase}
                        className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        Confirm Purchase
                    </button>
                </div>

        </div>
    );
};

export default Stock;
